const currentVersionId = -1

const passportVersionsConstants = { currentVersionId }
export default passportVersionsConstants
